import { render, staticRenderFns } from "./SyncRestfulApi.vue?vue&type=template&id=c80d5460"
import script from "./SyncRestfulApi.vue?vue&type=script&lang=js"
export * from "./SyncRestfulApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports